import { Component } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';

@Component({
  selector: 'bm-btn-cell',
  templateUrl: './btn-cell.component.html',
  styleUrls: ['./btn-cell.component.scss']
})
export class BtnCellComponent implements ICellRendererAngularComp {

  constructor() { }

  cellValue: any;

  agInit({value}) {
    this.cellValue = value;
  }

  refresh({value}) {
    this.cellValue = value;
    return true;
  }

}
